import { render, staticRenderFns } from "./Form_Staff.vue?vue&type=template&id=dffff8b4&scoped=true"
import script from "./Form_Staff.vue?vue&type=script&lang=js"
export * from "./Form_Staff.vue?vue&type=script&lang=js"
import style0 from "./Form_Staff.vue?vue&type=style&index=0&id=dffff8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffff8b4",
  null
  
)

export default component.exports